import { createSlice } from '@reduxjs/toolkit'

export const menuOpenSlice = createSlice({
  name: 'menuOpen',
  initialState: {
    value: false,
  },
  reducers: {
    toggleMenuOpen: (state, action) => {
      state.value =action.payload
    },
   
  },
})

// Action creators are generated for each case reducer function
export const { toggleMenuOpen } = menuOpenSlice.actions

export default menuOpenSlice.reducer